import React from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';

import TuringFooter from '../../components/TuringFooter/TuringFooter';
import '../../assets/css/Content.css';

const { Content } = Layout;

function VetsmithLayoutContainer (props) {
  const { children, showNavBar } = props;
  return (
    <Layout>
      <div className={`vetsmithContentColumn ${showNavBar ? 'navbar-padding' : ''}`}>
        <Content>
          {children}
        </Content>
        <TuringFooter />
      </div>
    </Layout>
  );
}

const mapStateToProps = (state) => {
  return Object.assign({}, {...state.drawer});
};

export default connect(mapStateToProps, null)(VetsmithLayoutContainer);